<template>
  <div class="text-semantic-surface-on-surface">
    <a :href="trailingSlashChecker(props.url)">
      <nuxt-img
        v-show="props.image"
        preload
        :src="props.image"
        width="417"
        height="214"
        :alt="props.title"
        class="rounded-lg w-full object-cover max-h-214"
        :loading="props.imageLazyLoad ? 'lazy' : 'eager'"
      />
    </a>

    <a
      :href="trailingSlashChecker(props.url)"
      class="text-xl mt-3 block"
    >
      <b>{{ trimText(props.title, 75) }}</b>
    </a>

    <p class="my-4">
      {{ trimText(props.content, 125) }}
    </p>

    <div class="flex items-center justify-between uppercase">
      <p class="text-sm">
        {{ props.author }}
      </p>
      <p class="text-sm">
        {{ stringToDate(props.date) }}
      </p>
    </div>
  </div>
</template>

<script setup>
defineOptions({
  name: 'AtomsPost'
})

const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  content: {
    type: String,
    default: ''
  },
  image: {
    type: String,
    default: null
  },
  author: {
    type: String,
    default: 'Compare Club'
  },
  date: {
    type: String,
    default: null
  },
  url: {
    type: String,
    default: null
  },
  imageLazyLoad: {
    type: Boolean,
    default: false
  }
})

const trimText = (text, maxLength) => {
  let textReturn = ''
  if (text) {
    textReturn = text.substring(0, maxLength) + (text.length > maxLength ? '...' : '')
  }
  return textReturn
}

const stringToDate = string => {
  let date = (!string || string) === '' ? '' : new Date(string)
  if (string !== '') {
    date = `${date.getDate()} ${date.toLocaleString('default', { month: 'long' })} ${date.getFullYear()}`
  }
  return date
}

const trailingSlashChecker = value => {
  value = trailingSlash(value)
  return value
}
</script>
